import { registerGame } from '../../core/GameRegistry';
import { useTensaiOrchestrator } from './useTensaiOrchestrator';
import TensaiSettingsPanel from './TensaiSettingsPanel';

export { default as Tensai } from './Tensai';
export { default as TensaiGame } from './TensaiGame';
export { default as GameScreen } from './GameScreen';
export { default as SoloGameScreen } from './SoloGameScreen';

const TensaiDefinition = {
  slug: 'tensai',
  name: 'Tensai',
  description: 'Choose your game mode',
  path: '/games/tensai',
  useOrchestrator: useTensaiOrchestrator,
  GameComponent: () => import('./Tensai'),
  instructions: 'How to Play:\nUse your mouse to click and drag a rectangle around a group of tiles adding to 10.\nEach tile cleared is one point.\nTry to score as many points as you can!',
  modes: [
    { key: 'solo',        label: 'Play Solo',        icon: '🎮', callbackProp: 'onPlaySolo' },
    { key: 'zen',         label: 'Play Zen Mode',     icon: '🧘', callbackProp: 'onPlayZen' },
    { key: 'daily',       label: 'Daily Challenge',   icon: '🏆', callbackProp: 'onDailyChallenge', dailyAware: true },
    { key: 'multiplayer', label: 'Play With Friends', icon: '👥', callbackProp: 'onPlayWithFriends' },
  ],
  SettingsPanel: TensaiSettingsPanel,
  features: {
    solo: true,
    multiplayer: true,
    zen: true,
    daily: true,
  },
};

registerGame(TensaiDefinition);
export default TensaiDefinition;
